import { Icon, type IconProps } from '@pfida-finance/ui/components';
import type { ReactNode } from 'react';
import { WIDGET_COLORS } from '../constants/colors';

type NoticeVariant = 'warn' | 'info' | 'danger' | 'success' | 'neutral' | 'dip';

const NOTICE_STYLES: Record<NoticeVariant, { bg: string; color: string }> = {
  warn: { bg: WIDGET_COLORS.amber.bg, color: WIDGET_COLORS.amber.text },
  info: { bg: WIDGET_COLORS.purple.bg, color: WIDGET_COLORS.purple.text },
  danger: { bg: WIDGET_COLORS.red.bg, color: WIDGET_COLORS.red.text },
  success: { bg: WIDGET_COLORS.green.bg, color: WIDGET_COLORS.green.text },
  neutral: { bg: WIDGET_COLORS.gray.bg, color: WIDGET_COLORS.gray.mid },
  dip: { bg: WIDGET_COLORS.dip.bg, color: WIDGET_COLORS.dip.text },
};

type Props = {
  variant: NoticeVariant;
  icon: IconProps['name'];
  children: ReactNode;
};

export function WidgetNotice({ variant, icon, children }: Props) {
  const { bg, color } = NOTICE_STYLES[variant];

  return (
    <div
      className="flex items-start gap-2 rounded-lg px-3.5 py-2.5 text-base font-medium mt-[12px]"
      style={{ backgroundColor: bg, color }}
    >
      <Icon name={icon} className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <span>{children}</span>
    </div>
  );
}
